






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { VNode, CreateElement } from 'vue';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import { AxiosResponse } from 'axios';
import VueAxios from 'vue-axios';
import { EnergyDisplay } from '../interfaces';
import Vuetify, { VLayout, VRow, VCol, VCard, VCardActions, VCardSubtitle, VCardText, VCardTitle  } from 'vuetify/lib';
import VRuntimeTemplate from 'v-runtime-template';

interface IDocumentHtmlContent {
    content: string;
    status: string;
    description: string;
}

@Component({
    components: {VRuntimeTemplate,
                 VLayout,
                 VRow,
                 VCol,
                 VCard,
                 VCardActions,
                 VCardSubtitle,
                 VCardText,
                 VCardTitle,
                },
})
export default class HtmlDocument extends Vue {
    private content: string = '';

    public async mounted() {
        const html = await this.fetchDocumentContent();
        this.content = html.content;
    }

    // Only valid for html
    private async fetchDocumentContent(): Promise<IDocumentHtmlContent> {
        const self = this;

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Token ' + self.$store.getters.Jwt,
        };

        return await axios
            .request<IDocumentHtmlContent>({
                method: 'GET',
                headers: headers,
                url:
                    'https://shimmyplus-default-backend.carnegosystems.net/documents/rest/get_document_content_from_id/' +
                    self.$route.params.id,
            })
            .then((response: AxiosResponse<IDocumentHtmlContent>) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error);
                return {
                    content: 'unknown',
                    status: 'unknown',
                    description: 'unknown',
                };
            });
    }
}
